const fillReviewsList = (reviews) => {
  const reviewsList = document.querySelector(".reviews-list");
  if (!reviewsList) return;

  const stars = reviewsList.innerHTML;
  reviewsList.innerHTML = ""; // Clear existing reviews
  reviews.forEach((review) => {
    const reviewItem = document.createElement("li");
    reviewItem.classList.add("review-item");

    const closest = Math.round((review.stars * 10) / 5) * 5;

    const reviewContent = `
      <div class="review-header">
      <h3 class="review-author">${review.consumer.displayName}</h3>
      <span class="review-rating">${stars
        .replace("hidden", "")
        .replace("stars", "stars stars" + closest)}</span>
 
      </div>
      <div class="review-body ellipsis">
      <p>${review.text}</p>
      </div>
      <div class="review-footer">
       <a data-wg-notranslate="true" href="${
         "https://www.trustpilot.com/reviews/" + review.id
       }" target="_blank">
          Verified by <svg style="margin-inline: 0.3em;" width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1929_24453)">
    <path d="M11.9987 5.08602H7.41716L6.00198 0.5L4.58246 5.08602L0.000946045 5.08145L3.7113 7.91855L2.29163 12.5L6.00198 9.66746L9.70784 12.5L8.29266 7.91855L11.9987 5.08602Z" fill="#33302D"></path>
    <path d="M8.61128 8.95572L8.29285 7.91846L6.00217 9.66737L8.61128 8.95572Z" fill="#F8F3ED"></path>
    </g>
    <defs>
    <clipPath id="clip0_1929_24453">
    <rect width="12" height="12" fill="white" transform="translate(0 0.5)"></rect>
    </clipPath>
    </defs>
  </svg> Trustpilot
        </a>

        <p class="review-date">${new Date(review.createdAt).toLocaleDateString(
          undefined,
          { year: "numeric", month: "short", day: "numeric" }
        )}</p>
    
      </div>
    `;

    reviewItem.innerHTML = reviewContent;
    reviewsList.appendChild(reviewItem);
  });
};

const getTrustPilotTotalz = async () => {
  try {
    let totalzRevData = JSON.parse(
      sessionStorage.getItem("totalzRevData") || "{}"
    );
    if (Object.keys(totalzRevData).length === 0) {
      const totalzRev = await fetch(
        "https://api.trustpilot.com/v1/business-units/61b021ae9580764bc1d19396/reviews?apikey=hm25GzJB7Yn7qV2KlezASDCoUZOZEWfR&stars=3,4,5"
      );
      totalzRevData = await totalzRev.json();
      sessionStorage.setItem("totalzRevData", JSON.stringify(totalzRevData));
    }
    let totalzData = JSON.parse(sessionStorage.getItem("totalzData") || "{}");

    if (Object.keys(totalzData).length === 0) {
      // get totals
      const totalz = await fetch(
        "https://api.trustpilot.com/v1/business-units/61b021ae9580764bc1d19396?apikey=hm25GzJB7Yn7qV2KlezASDCoUZOZEWfR"
      );
      totalzData = await totalz.json();
      sessionStorage.setItem("totalzData", JSON.stringify(totalzData));
    }
    const totalzReviews = totalzData.numberOfReviews.total;
    const totalzScore = totalzData.score.trustScore;

    fillReviewsList(totalzRevData.reviews);

    const nonaTrustPilotStarss = document.querySelectorAll(
      ".nona-trust-pilot-stars"
    );
    const nonaTrustPilotTotals = document.querySelectorAll(
      ".nona-trust-pilot-total"
    );

    const nonaTrustedBy = document.querySelectorAll(".nona-trusted-by");

    if (nonaTrustPilotStarss.length > 0 && nonaTrustPilotTotals.length > 0) {
      // on homepage get logo
      const starsUrl = totalzData.links.find(
        (l) => l.rel === "resources-images-stars"
      )?.href;
      const starsJson = await fetch(
        starsUrl + "?apikey=hm25GzJB7Yn7qV2KlezASDCoUZOZEWfR"
      );
      const starsData = await starsJson.json();

      const resourcesUrl = totalzData.links.find(
        (l) => l.rel === "resources-strings-stars"
      )?.href;
      const resourcesJson = await fetch(
        resourcesUrl + "?apikey=hm25GzJB7Yn7qV2KlezASDCoUZOZEWfR"
      );
      const resources = await resourcesJson.json();

      nonaTrustPilotStarss.forEach((star) => {
        star.src = starsData.star256x48.url;
        star.classList.remove("hide");
      });
      nonaTrustPilotTotals.forEach((total) => {
        total.innerText = totalzScore + "/5 - " + totalzReviews + " reviews";
        total.classList.remove("hide");
      });
      nonaTrustedBy.forEach((total) => {
        total.classList.remove("hide");
      });
    }
  } catch (e) {
    console.log("🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥error getting reviews", e);
  }
};

const setStarsOnProductCards = async () => {
  let productStarsData = JSON.parse(
    sessionStorage.getItem("productStarsData") || "{}"
  );

  const nonaJuneSku = "1003";
  const nonaSpritzSku = "2001";
  const nonaGingerSku = "2004";
  const glassSku = "3003";
  const threeTwentySku = "1010";
  const twoTwentySku = "1008";
  const giftBoxSku = "1004";
  const cockatilspoonSku = "3005";
  const tonicSku = "2007";
  const jiggerSku = "3006";
  const iceCubeSku= "3004";
  const allSkus = [
    nonaJuneSku,
    nonaSpritzSku,
    nonaGingerSku,
    glassSku,
    threeTwentySku,
    twoTwentySku,
    giftBoxSku,
    cockatilspoonSku,
    tonicSku,
    jiggerSku,
    iceCubeSku
  ];

  if (!productStarsData || Object.keys(productStarsData).length === 0) {
    const productStars = fetch(
      `https://api.trustpilot.com/v1/product-reviews/business-units/61b021ae9580764bc1d19396/batch-summaries?apikey=hm25GzJB7Yn7qV2KlezASDCoUZOZEWfR`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          apikey: "hm25GzJB7Yn7qV2KlezASDCoUZOZEWfR",
        },
        body: JSON.stringify({
          skus: allSkus,
        }),
      }
    );
    productStarsData = await productStars.then((res) => res.json());
    sessionStorage.setItem(
      "productStarsData",
      JSON.stringify(productStarsData)
    );
  }
  productStarsData.summaries.forEach((summary) => {
    const closest = Math.round((summary.starsAverage * 10) / 5) * 5;

    const productCards = document.querySelectorAll(
      `[data-sku="${summary.sku}"]`
    );
    productCards.forEach((card) => {
      card.classList.remove("opacity-0");
      card.classList.add("stars" + closest);
      if (
        card.classList.contains("show-review") &&
        card.parentElement.querySelector("#starsAverage") &&
        card.parentElement.querySelector("#numberReviews")
      ) {
        card.parentElement.querySelector("#starsAverage").innerText =
          summary.starsAverage;

        card.parentElement.querySelector("#numberReviews").innerText =
          summary.numberOfReviews.total;

        card.nextElementSibling.classList.remove("opacity-0");
      }
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  getTrustPilotTotalz();
  setStarsOnProductCards();
});
